import Swal from 'sweetalert2/dist/sweetalert2.js'
import { ENDPOINTS } from '@/components/constants';
import { API } from '@/utilities/api';

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

/**
 *  
 *  Topic filtering functionality
 * 
 */
export class Resources {

    /**
     * 
     * Contructor
     * 
     * @param {element} list - The list element to filter the suggestions into
     * @param {element} input - The input element to get the user query from
     * @param {element} clear_filters - The button to clear all of the selected search inputs
     * @param {element} search_info - The x of y search info box
     */
    constructor(grid, input, clear_filters, search_info) {
        this.query = '';
        this.resources = window.resources;
        this.grid = grid;
        this.page_limit = 48;
        this.current_page = 1;
        this.current_index = 0;
        this.filtered_resources = window.resources;
        this.pages = 0;
        this.filters = [];
        this.input = input;
        this.clear_filters = clear_filters;
        this.search_info = search_info;

        // Initialise the suggestion box interactions
        this.init();

        setTimeout(() => {
            // Update the search input placeholder once the JSON has loaded
            this.input.setAttribute('placeholder', `Search patient resources`);

            // Remove the spinning loader
            this.input.parentElement.querySelector('.spinning-loader').remove();
        }, 50);

    }

    printPDF(url) {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

        if (isStandalone) {
            // Fetch the PDF and force download
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const blobUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = url.split('/').pop();
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(blobUrl);
                })
                .catch(error => {
                    console.error('Download failed:', error);
                });
        } else {
            // Browser mode: Open and print when ready (using polling)
            const printWindow = window.open(url, '_blank');
            if (!printWindow) return;

            const checkReady = setInterval(() => {
                try {
                    if (printWindow.document && printWindow.document.readyState === 'complete') {
                        clearInterval(checkReady);
                        printWindow.focus();
                        printWindow.print();
                    }
                } catch (e) {
                    // Ignore cross-origin errors until it loads
                }
            }, 300);
        }
    }

    /**
     * 
     * Initialise the suggestion box interactions
     * 
     */
    init() {

        // Attach keyboard events to the input field
        this.input.addEventListener('keydown', (event) => {
            if (event.keyCode === 13) event.preventDefault();
        });


        // Attach keyboard events to the input field
        this.input.addEventListener('keyup', () => {
            // Set a timeout on the filter section 
            setTimeout(() => this.filter(), 50);
        });

        // Fetch the list of images on initial focus
        this.clear_filters.addEventListener('click', (event) => {
            event.preventDefault();
            this.clear();
        });

        this.filter();

        this.grid.addEventListener('click', (event) => {

            if (event.target.classList.contains('js-print-resource')) {
                event.preventDefault();
                this.printPDF(event.target.href);
            }

            if (event.target.classList.contains('js-email-resource')) {
                event.preventDefault();

                console.log('Email this resource');
                console.log('ID', event.target.dataset.id);

                Swal.fire({
                    title: '<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M792-696H168v419.69q0 5.39 3.46 8.85t8.85 3.46H536q11.07 0 18.54 7.4 7.46 7.41 7.46 18.39t-7.46 18.59Q547.07-212 536-212H180.31Q154-212 135-231q-19-19-19-45.31v-407.38Q116-710 135-729q19-19 45.31-19h599.38q27.01 0 45.66 19Q844-710 844-683.69V-448q0 11.07-7.41 18.54-7.4 7.46-18.38 7.46-10.98 0-18.59-7.46Q792-436.93 792-448v-248Zm-624 0v432-168.61 2.53V-696Zm312 179 312-179v62.69L497.08-463.77q-7.98 4.61-16.45 4.61-8.48 0-16.71-4.61L168-630.23V-696l312 179Zm310.16 305H652.24q-11.04 0-18.49-7.41-7.44-7.4-7.44-18.38 0-10.98 7.44-18.59 7.45-7.62 18.49-7.62h138.3l-49.17-49.17q-7.68-7.68-8.06-18.33-.39-10.65 7.92-19.06 7.92-7.82 18.58-7.44 10.65.38 18.39 8.15l89.16 89.36q5.02 5.04 7.64 10.59 2.61 5.56 2.61 12.02 0 6.07-2.61 11.82-2.62 5.75-7.23 10.37L778-125.92q-8.31 8.3-18.08 7.42-9.77-.89-17.69-8.81-8.31-8.31-8.31-18.19 0-9.89 8.31-18.19L790.16-212Z"></path></svg>Email this resource',
                    html:/*html*/`<p class="no-margin">Share this resource with a patient or colleague</p>`,
                    input: "email",
                    inputPlaceholder: "Enter an email address"
                }).then((result) => {
                    if (result.value) {
                        const url = new URL(ENDPOINTS.SHARE_RESOURCE);
                        fetch(url, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ recipient: result.value, resource_id: event.target.dataset.id })
                        })
                            .then(response => response.json())
                            .then((data) => {
                                if (data.status === 'ok') {
                                    Toast.fire({
                                        icon: 'success',
                                        title: 'Resource shared'
                                    })
                                } else {
                                    Toast.fire({
                                        icon: 'error',
                                        title: 'Resource not shared'
                                    })
                                }
                            })
                    }
                })
            }

            if (event.target.classList.contains('js-toggle-resource-favourite')) {
                let entity_id = event.target.dataset.entityId;
                let entity_type = 'resource';

                API.toggle_favourites({ entity_id, entity_type })
                    .then((response) => {

                        event.target.classList.toggle('hearted');

                        if (response.status !== 'ok' || response.message === 401) {
                            event.target.classList.remove('hearted');
                        }

                        // Toast.fire({
                        //     icon: (response.status === 'ok') ? 'success' : 'error',
                        //     title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to favourite images'
                        // });
                    });


            }

        });

    }


    clear() {

        // Clear the query
        this.query = '';

        // Clear the query input field
        this.input.value = '';

        // Update the search info box
        this.search_info.innerHTML = (this.query.length) ? `Showing ${this.filtered_topics.length} of ${this.topics.length} topics` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length ? 'add' : 'remove']('active');

        // Set a timeout on the filter section 
        setTimeout(() => this.filter(), 50);
    }

    /**
     * 
     * Filter a list of predefined search terms based on user input
     * 
     */
    filter() {

        // Reset the current page
        this.current_page = 0;

        // Update the query to match what a user has typed
        this.query = this.input.value.trim();

        if (this.query.length > 0) {
            // Filter the list of images based on the query 
            this.filtered_resources = this.resources.filter(item => item.title?.toLowerCase().includes(this.query.toLowerCase()));
        } else {
            this.filtered_resources = this.resources;
        }

        if (document.querySelector('.popular-visible')) {
            this.filtered_resources = this.filtered_resources.filter(item => item.popular === true);
        }

        // Show/hide the clear filters button based on search parameters being present
        this.clear_filters.classList[this.query.length || Object.keys(this.filters).length !== 0 ? 'add' : 'remove']('active');

        // Update the search info box
        this.search_info.innerHTML = (this.query.length || Object.keys(this.filters).length !== 0) ? `Showing ${this.filtered_resources.length} of ${this.filtered_resources.length} images` : '';

        // Show/hide the search info box based on search parameters being present
        this.search_info.classList[this.query.length || Object.keys(this.filters).length !== 0 ? 'add' : 'remove']('active');

        // Render the list of suggestions
        this.render();

    }





    /**
     * 
     * Render out the list of suggestions
     * 
     * @param {string} html - HTML template initialiser
     */
    render(html = '') {

        // Update the number of pages
        this.pages = Math.ceil(this.filtered_resources.length / this.page_limit);

        // Render out the images based on their position in the collection
        [...Array(this.page_limit).keys()].map((item, index) => {

            // Get the starting position of the images
            let itemIndex = index + this.current_page * this.page_limit;

            // Only add it to the HTML if it exists and we haven't looped nothing
            if (this.filtered_resources[itemIndex]) html += this.template(this.filtered_resources[itemIndex], index)
        });

        // Render the pagination if needed
        if (html) html += this.pagination(this.pages, this.current_page);

        // Render the HTML
        this.grid.innerHTML = (html === '') ? this.empty() : html;

    }

    paginationItem = (page, currentPage, pages) => {
        return /*html */`
        <button class="resources__wrap__grid__pagination__pages__item ${(page === currentPage) ? 'active' : ''} ${(page >= pages) ? 'hidden' : ''}" data-page="${page}">${page + 1}</button>`
    }

    pagination(pages, currentPage) {
        return /*html */`
        <div class="resources__wrap__grid__pagination"  style="${(pages === 1) ? `display:none;` : `display:flex;`}">
            <button class="resources__wrap__grid__pagination__first">
                <img src="_resources/themes/mercury/dist/images/svg/arrow-left-medium-blue.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-left-black">
            </button>
            ${[...Array((pages > 5) ? 5 : pages).keys()].map((item, index) => this.paginationItem((currentPage > 3 && pages > 5) ? index - 2 + currentPage : index, currentPage, pages)).join('')}
            <button class="resources__wrap__grid__pagination__last">
                <img src="_resources/themes/mercury/dist/images/svg/arrow-right-medium-blue.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-right-black">
            </button>
        </div>`
    }

    paginate(page) {

        // Update the current page based on the clicked element
        if (page === 'previous') {
            (this.current_page > 0) ? this.current_page-- : this.current_page = 0;
        } else if (page === 'next') {
            (this.current_page < this.pages - 1) ? this.current_page++ : this.current_page = this.pages - 1;
        } else { this.current_page = page; }


        // Rrender the images
        this.render();

        // Scroll to the top of the grid
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: this.grid.offsetTop + 200
        });

    }

    /**
     * 
     * Mark a searched term in the list of images
     * 
     * @param {string} name 
     * @returns {string} template 
     */
    marked(name) {
        if (this.query.length === 0) return name;
        let regex = new RegExp(this.query, 'gi');
        return name.replace(regex, `<span class="marked">$&</span>`);
    }



    /**
    * 
    * No results template
    * 
    * @returns {string} template
    */
    empty() {
        return /*html*/`
        <div class="topics__wrap__grid__column topics__wrap__grid__column--full">
            <div class="topics__wrap__grid__column__heading">
                <h3 class="h2">No results found</h3>
                <hr>
            </div>
        </div>`;
    }



    template(item, index) {
        let hearted = '';

        if (window.keeps) {
            let keep = window.keeps.data?.find(keep => parseInt(keep.entity_id) === parseInt(item.id) && keep.entity_type === 'resource');
            if (keep) hearted = 'hearted';
        }

        return /*html*/`
        <div class="resources__wrap__grid__item" data-index="${index}" data-popular="${item.popular}">
            <div href="${item.link}" class="resources__wrap__grid__item__thumbnail">
                <a href="${item.link}" class="resources__wrap__grid__item__thumbnail__link">
                    <img src="${item.thumbnail}" alt="${item.title}" width="843" height="596" loading="lazy">
                </a>
                <div class="images__wrap__grid__item__heart [ js-toggle-resource-favourite ] ${hearted}" data-entity-id="${item.id}">
                <span class="heart">
                    <img class="heart__image-1" src="/_resources/themes/mercury/dist/images/svg/heart-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <img class="heart__image-2" src="/_resources/themes/mercury/dist/images/svg/heart-full-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" stroke="#ff5050" fill="none" fill-rule="evenodd" />
                    </svg>
                </span>
            </div>
            </div> 
            <a href="${item.link}" class="resources__wrap__grid__item__details">
                <span data-category="${item.category}" class="resources__wrap__grid__item__details__category">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M371.96-250h215.76q11.05 0 18.66-7.41 7.62-7.4 7.62-18.38 0-10.98-7.45-18.59-7.46-7.62-18.51-7.62H372.28q-11.05 0-18.66 7.41-7.62 7.4-7.62 18.38 0 10.98 7.45 18.59 7.46 7.62 18.51 7.62Zm0-144h215.76q11.05 0 18.66-7.41 7.62-7.4 7.62-18.38 0-10.98-7.45-18.59-7.46-7.62-18.51-7.62H372.28q-11.05 0-18.66 7.41-7.62 7.4-7.62 18.38 0 10.98 7.45 18.59 7.46 7.62 18.51 7.62Zm-95.93 278q-27.03 0-45.53-18.65T212-180.31v-599.38q0-27.01 18.65-45.66Q249.3-844 276.31-844h282.77q12.68 0 24.42 4.62 11.73 4.61 21.58 14.46l123.84 123.84q9.85 9.85 14.46 21.58 4.62 11.74 4.62 24.42v474.77q0 27.01-18.66 45.66Q710.68-116 683.65-116H276.03ZM548-676.16V-792H276.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v599.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-644H580.16q-13.77 0-22.96-9.2-9.2-9.19-9.2-22.96ZM264-792v148-148V-168v-624Z"/></svg>
                </span>
                <p>${this.marked(item.title)}</p>
            </a> 
            <div class="resources__wrap__grid__item__actions">
                <a href="${item.leaflet}" class="[ js-print-resource ]">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M324.31-164q-26.53 0-45.42-18.86Q260-201.71 260-228.19v-79.58h-68.15q-26.53 0-45.42-18.86-18.89-18.85-18.89-45.68v-163.38q0-31.5 22.04-53.75t53.96-22.25h552.92q31.5 0 53.75 22.25t22.25 53.75v163.38q0 26.53-18.86 45.42Q794.75-308 768.27-308h-68.04v79.69q0 26.53-18.86 45.42Q662.52-164 635.69-164H324.31ZM191.85-360H260q.77-25.85 19.43-44.31 18.67-18.46 44.88-18.46h311.38q26.21 0 44.88 18.46Q699.23-385.85 700-360h69.15q5.39 0 8.85-3.46t3.46-8.85v-149.06q0-16.32-12-27.32t-28-11H217.54q-16.15 0-27.08 11.04-10.92 11.04-10.92 27.36v148.98q0 5.39 3.46 8.85t8.85 3.46ZM648-611.69v-107.69q0-5.39-3.46-8.85t-8.85-3.46H324.31q-5.39 0-8.85 3.46t-3.46 8.85v107.69h-52v-107.69q0-26.83 18.89-45.57 18.89-18.74 45.42-18.74h311.38q26.53 0 45.42 18.89T700-719.38v107.69h-52Zm52.1 148q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM648-228.31v-130.15q0-5.39-3.46-8.85t-8.85-3.46H324.31q-5.39 0-8.85 3.46t-3.46 8.85v130.15q0 5.39 3.46 8.85t8.85 3.46h311.38q5.39 0 8.85-3.46t3.46-8.85ZM191.85-559.69H179.54h601.92H191.85Z"/></svg>
                </a>
                <a href="${item.url}" class="[ js-email-resource ]" data-id="${item.id}">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M792-696H168v419.69q0 5.39 3.46 8.85t8.85 3.46H536q11.07 0 18.54 7.4 7.46 7.41 7.46 18.39t-7.46 18.59Q547.07-212 536-212H180.31Q154-212 135-231q-19-19-19-45.31v-407.38Q116-710 135-729q19-19 45.31-19h599.38q27.01 0 45.66 19Q844-710 844-683.69V-448q0 11.07-7.41 18.54-7.4 7.46-18.38 7.46-10.98 0-18.59-7.46Q792-436.93 792-448v-248Zm-624 0v432-168.61 2.53V-696Zm312 179 312-179v62.69L497.08-463.77q-7.98 4.61-16.45 4.61-8.48 0-16.71-4.61L168-630.23V-696l312 179Zm310.16 305H652.24q-11.04 0-18.49-7.41-7.44-7.4-7.44-18.38 0-10.98 7.44-18.59 7.45-7.62 18.49-7.62h138.3l-49.17-49.17q-7.68-7.68-8.06-18.33-.39-10.65 7.92-19.06 7.92-7.82 18.58-7.44 10.65.38 18.39 8.15l89.16 89.36q5.02 5.04 7.64 10.59 2.61 5.56 2.61 12.02 0 6.07-2.61 11.82-2.62 5.75-7.23 10.37L778-125.92q-8.31 8.3-18.08 7.42-9.77-.89-17.69-8.81-8.31-8.31-8.31-18.19 0-9.89 8.31-18.19L790.16-212Z"/></svg>
                </a>
            </div> 
        </div>`;
    }

}